import { Grid, TextField, Typography } from "@mui/material";
import { FormikErrors, FormikTouched } from "formik";
import ImageCard from "src/grading/components/ImageCard/ImageCard";
import {
  JoinPageContent,
  Organization,
} from "src/store/reducers/organizations/organizationsApiSlice";
import useStyles from "./OrgRegistration.styles";

interface OrgRegistrationProps {
  joinPageContent?: JoinPageContent;
  onFieldChange: (field: string, value: string) => void;
  onFileSelect: (file: File) => void;
  touched: FormikTouched<Organization>;
  errors: FormikErrors<Organization>;
}

const OrgRegistration = ({
  joinPageContent,
  onFieldChange,
  onFileSelect,
}: OrgRegistrationProps) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.container} gap={3}>
      <Grid item xs={12}>
        <Typography variant="h4">Registration Page Content</Typography>
      </Grid>
      <Grid container>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black">
            Title
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <TextField
            fullWidth
            variant="outlined"
            value={joinPageContent?.testTitle || ""}
            placeholder="Join page title"
            onChange={(e) =>
              onFieldChange("joinPageContent.testTitle", e.target.value)
            }
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black">
            Description 1
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            value={joinPageContent?.testBody || ""}
            placeholder="Join page description 1"
            rows={4}
            onChange={(e) =>
              onFieldChange("joinPageContent.testBody", e.target.value)
            }
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black">
            Description 2
          </Typography>
        </Grid>
        <Grid container mb={2}>
          <TextField
            fullWidth
            multiline
            variant="outlined"
            value={joinPageContent?.organizationBody || ""}
            placeholder="Join page description 2"
            rows={4}
            onChange={(e) =>
              onFieldChange("joinPageContent.organizationBody", e.target.value)
            }
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid container mb={1}>
          <Typography variant="h5" fontWeight="bold" color="black">
            Image
          </Typography>
        </Grid>
        <Grid container justifyContent="center">
          <ImageCard
            imageContainerStyles={classes.backgroundImageContainer}
            src={joinPageContent?.organizationImageUrl || ""}
            onFileSelect={onFileSelect}
          />
        </Grid>
        {/* <Grid container mb={2}>
          <TextField
            fullWidth
            variant="outlined"
            value={joinPageContent?.organizationImageUrl || ""}
            placeholder="Image"
            onChange={(e) =>
              onFieldChange(
                "joinPageContent.organizationImageUrl",
                e.target.value,
              )
            }
          />
        </Grid> */}
      </Grid>
    </Grid>
  );
};

export default OrgRegistration;
